import React, { useState } from 'react'

import { Button, Checkbox, FormControlLabel, FormGroup, TableCell, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { cloneDeep } from 'lodash'
import PropTypes from 'prop-types'

import { LabeledCheckMark, LabeledX, RequiredStar } from './components/Icons'
import SectionTable from './components/SectionTable'
import SkeletonPair from './components/SkeletonPair'
import { configurableProfileSections, coreProfileSections } from './constants'

const useStyles = makeStyles({
  profileSectionRow: {
    height: 55,
  },
})
const ProfileSection = ({ isEditing, applicationConfig, setApplicationConfig, loading, getStyle }) => {
  const [showCoreProfileSections, setShowCoreProfileSections] = useState(false)
  const firstYearConfig = applicationConfig.firstYearConfiguration
  const transferConfig = applicationConfig.transferConfiguration
  const classes = useStyles()

  const onToggleProfileSection = (newVal, id, isFirstYear) => {
    const updatedState = cloneDeep(applicationConfig)

    if (isFirstYear) {
      updatedState.firstYearConfiguration.profileSections[id] = newVal
    } else {
      updatedState.transferConfiguration.profileSections[id] = newVal
    }
    setApplicationConfig(updatedState)
  }
  const getReadOnlyView = (configValue, isEnabled) =>
    configValue ? (
      <LabeledCheckMark
        enabled={isEnabled}
        getStyle={getStyle}
      />
    ) : (
      <LabeledX
        enabled={isEnabled}
        getStyle={getStyle}
      />
    )
  const renderProfileSectionConfig = (section, config, firstYearConfig = false) => {
    const isEnabled = config && config.enabled
    const profileSections = config && config.profileSections ? config.profileSections : {}
    return isEditing ? (
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={profileSections[section.id]}
              onChange={(e) => onToggleProfileSection(e.target.checked, section.id, firstYearConfig)}
              name={section.label}
              color="primary"
              disabled={!isEnabled}
              label="Include"
            />
          }
          label="Include"
        />
      </FormGroup>
    ) : (
      getReadOnlyView(profileSections[section.id], isEnabled)
    )
  }

  return (
    <SectionTable
      sectionName="Sections"
      getStyle={getStyle}
    >
      {configurableProfileSections &&
        configurableProfileSections.map((section) => {
          return (
            <TableRow
              data-testid="profile-section-row"
              key={section.id}
              className={classes.profileSectionRow}
            >
              <TableCell
                style={{ color: getStyle() }}
                align="left"
                variant="body"
                component="th"
                size="small"
              >
                {section.label}
              </TableCell>
              <TableCell
                align="left"
                size="small"
              >
                {loading && <SkeletonPair />}

                {!loading && renderProfileSectionConfig(section, firstYearConfig, true)}
              </TableCell>
              <TableCell
                align="left"
                size="small"
              >
                {loading && <SkeletonPair />}
                {!loading && renderProfileSectionConfig(section, transferConfig)}
              </TableCell>
            </TableRow>
          )
        })}
      {showCoreProfileSections &&
        coreProfileSections &&
        coreProfileSections.map((section) => (
          <TableRow
            data-testid="profile-section-row"
            key={section.id}
            className={classes.profileSectionRow}
          >
            <TableCell
              style={{ color: getStyle() }}
              align="left"
              variant="body"
              component="th"
              size="small"
            >
              {section.label}
            </TableCell>
            <TableCell
              align="left"
              size="small"
            >
              {loading ? (
                <SkeletonPair />
              ) : (
                <RequiredStar
                  enabled={firstYearConfig && firstYearConfig.enabled}
                  hideLabel={false}
                  getStyle={getStyle}
                />
              )}
            </TableCell>
            <TableCell
              align="left"
              size="small"
            >
              {loading ? (
                <SkeletonPair />
              ) : (
                <RequiredStar
                  enabled={transferConfig && transferConfig.enabled}
                  hideLabel={false}
                  getStyle={getStyle}
                />
              )}
            </TableCell>
          </TableRow>
        ))}
      <TableRow>
        <TableCell colSpan={3}>
          <Button
            color="primary"
            onClick={() => setShowCoreProfileSections(!showCoreProfileSections)}
          >
            {showCoreProfileSections ? '- Hide Core Sections' : '+ Show Core Sections'}
          </Button>
        </TableCell>
      </TableRow>
    </SectionTable>
  )
}

ProfileSection.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  applicationConfig: PropTypes.object.isRequired,
  setApplicationConfig: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getStyle: PropTypes.func.isRequired,
}

export default ProfileSection
